import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import GeneratorComp from "./GeneratorComp"

const Generator =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <GeneratorComp/>
        </div>
        <Footer />
        </>
    )
}

export default Generator;